'use strict';

var Sugar = require('sugar-core');

Sugar.String.defineInstance({

  'remove': function(str, f) {
    return str.replace(f, '');
  }

});

module.exports = Sugar.String.remove;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/string/remove.js
// module id = 921
// module chunks = 0